import React from "react";
import { cx, css } from "@emotion/css";
import aciLogo from "../img/aci-logo-full.svg";
import bs from "../css/bootstrap.module.css";

export const Header = () => {
  const pageHeader = css`
    margin: 10px 0;
    label: pageHeader;
  `;
  const headerLogo = css`
    width: 175px;
    height: 50px;
    vertical-align: middle;
    label: headerLogo;
  `;
  const containerFullwidth = css`
    width: 100%;
    background: #3b3e3e;
    color: #fff;
    padding: 15px 0;
    margin-bottom: 50px;
    label: containerFullwidth;
  `;
  const headerText = css`
    font-family: "Merriweather", serif;
    margin: 0;
    text-align: center;
    font-size: 1.5em;
    color: #fff;
    label: headerText;
  `;

  return (
    <header>
      <div className={bs.container}>
        <div className={bs.row}>
          <div className={cx(pageHeader, bs["col-md-12"])}>
            <img
              src={aciLogo}
              className={cx(headerLogo)}
              alt="American Century Investments Logo"
            />
          </div>
        </div>
      </div>
      <div className={containerFullwidth}>
        <div className={bs.container}>
          <div className={bs.row}>
            <div className={bs["col-md-12"]}>
              <h1 className={headerText} id="headerText">
                Transfer an account to American Century Investments
                <sup>&reg;</sup>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
